import { React, useEffect } from "react";
import Header from "./Header1";
import Footer from "./Footer";
import { Container } from "react-bootstrap";

import { Charterlist } from "../Actions/cmsFrontAxios";
import { useState } from "react";

const Charter = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });

  useEffect(() => {
    GetCharterlists();
  }, []);

  const [Charterdata, setCharterdata] = useState();

  const GetCharterlists = async () => {
    try {
      let resp = await Charterlist();
      console.log("GetParadigmlist", resp.data);
      setCharterdata(resp.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <Header />

      <article className="innerpages">
        <section className="explaincontents">
          <Container>
            <h1 className="innerhead">Node AI charter</h1>
            <div className="paracontents">
              {/* {Charterdata &&
                Charterdata.map((item) => {
                  return (
                    <p
                      className="content"
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }}></p>
                  );
                })} */}

              <p className='content'>
              Node AI itself cannot have a charter. Its core technology is a consensus mechanism, which reaches agreement about how its preferences should be distributed to participants in an open and un−permissioned network. If it has preferences itself, they are openness and decentralization, which are immutably written into its code.
                          </p>
                          <p className='content'>
                          As such, this document merely outlines the principles and commitments of those who use Node AI as a medium to express their subjective preferences on top of its playing field. It is signed by The Open node Foundation and other entities that believe in Node AI's vision of decentralized AI.
                          </p>
                          <p className='content'>
                          There is wide agreement that the blossoming of Artificial Intelligence offers up tremendous promise − and risk − for humanity's relationship with technology along multiple axes. Those include its potential use to abuse humans, long term existential risk to the human race, and its ability to increase power imbalances. We acknowledge the following principles as our commitments to stop those outcomes. Those are:                          </p>
                          <p className='content'>
                          We are committed to safeguarding AI from being totally controlled or regulated by governments, powerful corporations, and the individuals signing this document. We believe that excessive centralization of AI poses the greatest risk to the human race, within or without Node AI. Concentration of power will inevitably create biased decision−making, controlled access to benefits and significant abuse. Recognizing that AI is the most powerful technology humanity has created to date, it is vital that we ensure its governance sits in the hands of the many rather than the few. To ensure this we are further committed to:                          </p>
                          <p className='content'>
                          We firmly oppose the misuse of AI for harmful intent, and will actively strive to prevent the spread of harmful content. We also pledge to advocate for the positive, ethical and life−affirming application of AI. Simultaneously, we will actively work to diffuse control over these preferences, in the name of decentralized power, with the express purpose of leveraging the collective wisdom and judgment of humanity around the exceedingly and increasingly difficult questions AI as a technology poses. In pursuit of this, we embrace:                          </p>
                          <p className='content'>
                          The Node AI Network inherently allows open and un−permissioned ownership accrual to those who contribute. We, the signatories, will work to clear the path, through which individuals may work to participate, and therefore gain real control in the development of AI. This is necessary to ensure as many humans as possible have access, influence, and hard power in the future that we are creating together. This principle is reinforced by our commitment to:                          </p>


                          <p className='content'> We are totally committed to open−source development of all of our work within the Node AI ecosystem; whether it be mining, validating, subnetwork creation or any other value−creating software, and will actively support open−source development projects, education initiatives and those who seek to lower barriers to entry at all levels. We recognize the importance of collaborative efforts and community−driven initiatives to unlock the true potential of AI; all of which can contribute to Node AI. We will bolster this by upholding our value of:</p>
                          <p className='content'> The Node AI blockchain's value transfers are at all times completely transparent. We, the signatories, are further committed to total transparency of Node AI's decision making process above and beyond what is already public, with the intention of making it clear what our votes in the DAO entail, and why we distribute our preferences in this way to direct Node AI.</p>
                          <p className='content'> We have chosen Node AI as our common platform to represent our shared values for an open and decentralized future of AI. We are devoted to opposing centralized control and encouraging decentralized decision−making through open−ownership, software development, and superior transparency. We believe together, we can shape an AI landscape that truly serves the collective interests of humanity</p>
            </div>
          </Container>
        </section>
      </article>

      <Footer />
    </>
  );
};

export default Charter;
